import { BankFindDto, type BankFindInterface } from '@zaoblako/shared/modules/catalog/dtos/bank/bank-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { ClientDtoKeysEnum } from '@zaoblako/shared/modules/client/enums/client-dto-keys.enum';
import type { CompanyFindInterface } from '@zaoblako/shared/modules/client/dtos/company/find/company-find.dto';
import type { ContragentFindInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-find.dto';

import * as yup from 'yup';

/** Bank details response body */
export interface BankDetailsFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;
  /** Display name */
  name?: string;
  /** Checking account number */
  checkingAccount: string;
  /** Bank details creation date and time */
  created: Date;
  /** Bank details last update date and time */
  updated: Date;
  /** Bank information (BIC, correspondent account etc.) */
  bank?: BankFindInterface;
  /**
   * Are this bank details being used by some BRS task or
   * BRS task template (using by BRS APIs only)
   */
  isSelected?: boolean;
  /** Contragent which use this bank details */
  contragent?: ContragentFindInterface;
  /** Company which use this bank details */
  company?: CompanyFindInterface;
}

/** Bank details response body - DTO schema */
export const BankDetailsFindDto = SerdeDtoClass.create<BankDetailsFindInterface>(ClientDtoKeysEnum.BANK_DETAILS_FIND_DTO, {
  id: {
    label: 'Номер в ФРМ',
    serializer: yup.number(),
  },
  name: {
    optional: true,
    sortable: true,
    label: 'Название',
    serializer: yup.string(),
  },
  checkingAccount: {
    sortable: true,
    label: 'Номер в банке',
    serializer: yup.string(),
  },
  created: {
    sortable: true,
    label: 'Дата создания',
    serializer: yup.date(),
  },
  updated: {
    sortable: true,
    label: 'Дата создания',
    serializer: yup.date(),
  },
  bank: {
    optional: true,
    sortable: true,
    label: 'Банк',
    nested: BankFindDto,
    serializer: (_, nested) => nested,
  },
  isSelected: {
    label: 'Выбран',
    optional: true,
    serializer: yup.boolean(),
  },
  contragent: {
    sortable: true,
    label: 'Контрагент',
    optional: true,
    nested: ClientDtoKeysEnum.CONTRAGENT_FIND_DTO,
    serializer: (_, nested) => nested,
  },
  company: {
    sortable: true,
    label: 'Компания',
    optional: true,
    nested: ClientDtoKeysEnum.COMPANY_FIND_DTO,
    serializer: (_, nested) => nested,
  },
});
